import styled from 'styled-components';

interface ButtonProps {
  disabled?: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1200px) {
    padding: 0 14px;
    border-radius: 0;
  }
`;

export const Title = styled.div`
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 36px;
  color: #070c2f;
  margin-top: 50px;
  margin-bottom: 20px;
`;
export const SubTitle = styled.div`
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 130%;
  color: #222222;

  margin-bottom: 40px;
`;

export const Container = styled.div`
  max-width: 1200px;
`;

export const ContentWrapper = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  @media (max-width: 1200px) {
    border-radius: 0px;
    margin: 0 -14px;
  }
`;

export const Content = styled.div`
  overflow: auto;
  max-height: 492px;
  p {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 130%;
    color: #222222;
  }

  * {
    margin: revert;
    padding: revert;
    outline: revert;
    box-sizing: revert;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Button = styled.button<ButtonProps>`
  /* background: ${(props) => (props.disabled ? '#e4e4e4' : '#3c50e0')}; */
  /* color: ${(props) => (props.disabled ? '#646464' : '#FFFFFF')}; */
  /* cursor: ${(props) => (props.disabled ? 'auto' : 'pointer')}; */

  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 140%;

  padding: 18px 24px;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  margin: 20px 0px 34px;
  white-space: nowrap;
  /* Cor primária */
  color: ${({ theme }) => theme.colors.primary};
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &.agree {
    background: ${({ theme }) => theme.colors.primary};
    color: white;
  }
`;

export const Warning = styled.div`
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  margin: 32px 0px;

  min-height: 30px;
  display: flex;
  align-items: center;
  > :first-child {
    height: 28px;
    margin-right: 16px;
    @media (max-width: 500px) {
      height: 80px;
      width: 80px;
    }
  }
`;
